import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import userService from "../../services/userService";

export const getNotifications = createAsyncThunk(
    "notification/getNotifications",
    async () => {
        const response = await userService.getNotifications();
        return response.data;
    }
);

export const markNotificationAllRead = createAsyncThunk(
    "notification/markNotificationAllRead",
    async () => {
        const response = await userService.markNotificationsAllRead();
        return response.data;
    }
);

const initialState = {
    loading: false,
    notifications: '',
    notificationDescription: '',
    unreadMsgs: ''
};

const notificationSlice = createSlice({
    name: "notification",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getNotifications.pending, (state, action) => {
           // state.loading = true;
        });
        builder.addCase(getNotifications.fulfilled, (state, action) => {
          //  state.loading = false;
            state.notifications = action.payload.notifications;
            state.notificationDescription = action.payload.notificationDescriptions;
            state.unreadMsgs = action.payload.totalUnReadNotifications;
        });
        builder.addCase(getNotifications.rejected, (state, action) => {
          //  state.loading = false;
        });
        builder.addCase(markNotificationAllRead.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(markNotificationAllRead.fulfilled, (state, action) => {
            state.loading = false;
            state.notifications = action.payload.notifications;
            state.notificationDescription = action.payload.notificationDescriptions;
            state.unreadMsgs = action.payload.totalUnReadNotifications;
        });
        builder.addCase(markNotificationAllRead.rejected, (state, action) => {
            state.loading = false;
        });
    }
});

export default notificationSlice.reducer;